import { render, staticRenderFns } from "./AddingBlock.vue?vue&type=template&id=28ece9e2&scoped=true&"
import script from "./AddingBlock.vue?vue&type=script&lang=js&"
export * from "./AddingBlock.vue?vue&type=script&lang=js&"
import style0 from "./AddingBlock.vue?vue&type=style&index=0&id=28ece9e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ece9e2",
  null
  
)

export default component.exports